import stocksData from './stocksData.json';

export const STOCKS_DATA = stocksData;
